import React, { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { selectLoveInterest } from '../../../../services/assessment';
import { assessmentAtom } from "../../../../state/assessment";
import { loveInterestAtom } from '../../../../state/assessment';
import Progress from "../../progress";
import Joey from "../../../../resources/imgs/assessment/characters/Joey.svg"
import Karl from "../../../../resources/imgs/assessment/characters/Karl.png"
import Manuel from "../../../../resources/imgs/assessment/characters/Manuel.png"
import Pamela from "../../../../resources/imgs/assessment/characters/Pamela.png"
import Peter from "../../../../resources/imgs/assessment/characters/Peter.png"
import Reina from "../../../../resources/imgs/assessment/characters/Reina.png"
import Roy from "../../../../resources/imgs/assessment/characters/Roy.png"
import Samantha from "../../../../resources/imgs/assessment/characters/Samantha.png"
import Trish from "../../../../resources/imgs/assessment/characters/Trish.png"

import Joey1 from "../../../../resources/imgs/assessment/characters/joey1.png"
import Karl1 from "../../../../resources/imgs/assessment/characters/karl1.png"
import Manuel1 from "../../../../resources/imgs/assessment/characters/manuel1.png"
import Pamela1 from "../../../../resources/imgs/assessment/characters/pamela1.png"
import Peter1 from "../../../../resources/imgs/assessment/characters/peter1.png"
import Reina1 from "../../../../resources/imgs/assessment/characters/reina1.png"
import Roy1 from "../../../../resources/imgs/assessment/characters/roy1.png"
import Samantha1 from "../../../../resources/imgs/assessment/characters/samantha1.png"
import Trish1 from "../../../../resources/imgs/assessment/characters/trish1.png"

export default function Index(props) {
  const assessment = useRecoilValue(assessmentAtom);
  const setAssessment = useSetRecoilState(assessmentAtom);
  const setLoveInterest = useSetRecoilState(loveInterestAtom);
  const [initialData, setData] = useState([
    { img: Manuel, otherImg: Manuel1, name: "Manuel", dish: [0, 1, 2], visible: true },
    { img: Pamela, otherImg: Pamela1, name: "Pamela", dish: [3, 0, 4], visible: true },
    { img: Trish, otherImg: Trish1, name: "Trish", dish: [1, 3, 5], visible: true },
    { img: Karl, otherImg: Karl1, name: "Karl", dish: [4, 5, 0], visible: true },
    { img: Joey, otherImg: Joey1, name: "Joey", dish: [5, 3, 4], visible: true },
    { img: Reina, otherImg: Reina1, name: "Reina", dish: [2, 5, 0], visible: true },
    { img: Peter, otherImg: Peter1, name: "Peter", dish: [2, 5, 0], visible: true },
    { img: Roy, otherImg: Roy1, name: "Roy", dish: [2, 5, 0], visible: true },
    { img: Samantha, otherImg: Samantha1, name: "Samantha", dish: [2, 5, 0], visible: true },
  ]);

  // Function to shuffle an array randomly (Fisher-Yates algorithm)
  const shuffleArray = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const nextStep = async (name) => {
    // Set the selected character as the love interest (as an object for compatibility)
    setLoveInterest({ loveInterest: name });
    
    const remainingData = initialData.filter(obj => obj.name !== name);

    const shuffledData = shuffleArray(remainingData);
    const randomSelection = shuffledData.slice(0, 5);

    const finalSelection = [...randomSelection, initialData.filter(item => item.name === name)[0]];
    
    console.log('🎭 Module 1-0 setting cardData with:', finalSelection.map(c => c.name));
    console.log('💕 Module 1-0 setting love interest to:', name);
    props.setData(finalSelection);
    props.nextPage();
  }

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="00." percent={0} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 0</div>
          <div className="module1-body">
            <div className="module1-title">
              Choose your love interest!
            </div>
          </div>
        </div>
      </div>
      <div className="module1-pictures">
        <img src={Joey} onClick={() => nextStep("Joey")} />
        <img src={Karl} onClick={() => nextStep("Karl")} />
        <img src={Manuel} onClick={() => nextStep("Manuel")} />
        <img src={Pamela} onClick={() => nextStep("Pamela")} />
        <img src={Peter} onClick={() => nextStep("Peter")} />
        <img src={Reina} onClick={() => nextStep("Reina")} />
        <img src={Roy} onClick={() => nextStep("Roy")} />
        <img src={Samantha} onClick={() => nextStep("Samantha")} />
        <img src={Trish} onClick={() => nextStep("Trish")} />
      </div>
    </div>
  )
}
